import { styled, css, th, type Theme, type FlattenInterpolation } from '@elliemae/ds-system';
import { background, borders, sizing, space, boxShadows } from '@elliemae/ds-system';

import type {} from '@xstyled/system';
import type { SvgIconT } from './react-desc-prop-types.js';
import { DSIconName, DSIconSlots } from './theming.js';

interface StyledWrapperPropsT {
  size: SvgIconT.SizeType | undefined;
  svgColor?: string | undefined;
  width: string | number | undefined;
  height: string | number | undefined;
}

const displaySizes = css`
  display: inline-flex;
  vertical-align: middle;
`;
export const xxlSizes = css`
  width: 4rem;
  height: 4rem;
  @media (min-width: ${th.breakpoint('small')}) {
    width: 4.923rem;
    height: 4.923rem;
  }
`;

export const xlSizes = css`
  width: 3rem;
  height: 3rem;
  @media (min-width: ${th.breakpoint('small')}) {
    width: 3.692rem;
    height: 3.692rem;
  }
`;

export const lSizes = css`
  width: 2rem;
  height: 2rem;
  @media (min-width: ${th.breakpoint('small')}) {
    width: 2.462rem;
    height: 2.462rem;
  }
`;

export const mSizes = css`
  width: 1.5rem;
  height: 1.5rem;
  @media (min-width: ${th.breakpoint('small')}) {
    width: 1.846rem;
    height: 1.846rem;
  }
`;

export const sSizes = css`
  width: 1rem;
  height: 1rem;
  @media (min-width: ${th.breakpoint('small')}) {
    width: 1.231rem;
    height: 1.231rem;
  }
`;

export const xsSizes = css`
  width: 0.5rem;
  height: 0.5rem;
  @media (min-width: ${th.breakpoint('small')}) {
    width: 0.615rem;
    height: 0.615rem;
  }
`;

export const xxsSizes = css`
  width: 0.25rem;
  height: 0.25rem;
  @media (min-width: ${th.breakpoint('small')}) {
    width: 0.308rem;
    height: 0.308rem;
  }
`;

export const standarSizes = css`
  ${sSizes}
`;

export const getSize = (
  size: SvgIconT.SizeType | undefined,
): FlattenInterpolation<{
  theme: Theme;
}> => {
  if (size === 'xxl') return xxlSizes;
  if (size === 'xl') return xlSizes;
  if (size === 'l') return lSizes;
  if (size === 'm') return mSizes;
  if (size === 's') return sSizes;
  if (size === 'xs') return xsSizes;
  if (size === 'xxs') return xxsSizes;
  return standarSizes;
};

export const StyledSvg = styled('svg', {
  name: DSIconName,
  slot: DSIconSlots.SVG,
})<StyledWrapperPropsT>`
  ${({ width, height, theme, size }) => {
    if (size) return getSize(size);

    if (String(width).includes('rem') && String(height).includes('rem'))
      return `
    width: ${width as string};
    height: ${height as string};
    `;

    return `
    width: ${(width as number) / 16}rem;
    height: ${(height as number) / 16}rem;

    @media (min-width: ${theme.breakpoints?.small}) {
      width: ${(width as number) / 13}rem;
      height: ${(height as number) / 13}rem;

    }`;
  }}
`;

export const StyledWrapper = styled('span', {
  name: DSIconName,
  slot: DSIconSlots.ICON_WRAPPER,
})<StyledWrapperPropsT>`
  ${({ width, height, size, theme }) => {
    if (size) return getSize(size);
    if (String(width).includes('rem') && String(height).includes('rem'))
      return `
    width: ${width as string};
    height: ${height as string};
    `;

    return `
    width: ${(width as number) / 13}rem;
    height: ${(height as number) / 13}rem;

    @media (max-width: ${theme.breakpoints?.small}) {
      width: ${(width as number) / 16}rem;
      height: ${(height as number) / 16}rem;

    }`;
  }}
  ${displaySizes}
  
  & svg path[fill="none"] {
    stroke: #000;
  }
  ${({ svgColor, theme }) => {
    if (svgColor)
      return `
      & svg {
        path[fill="none"] {
          stroke: ${th.color(svgColor, svgColor)({ theme })} !important;
        } 
        fill: ${th.color(svgColor, svgColor)({ theme })} !important;
      }`;
  }}

  ${background}
  ${borders}
  ${space}
  ${boxShadows}
`;
// ⇧⇧⇧⇧⇧⇧
// we cannot use xStyledProps because has a conflict in how we use the color prop

// this has to be done to cover the cases where the svg has a path with fill none and
// the color is given by the stroke
// & svg path[fill="none"] {
//   stroke: #000;
// }
